import React from 'react';

import SceneLessonPage from './SceneLessonPage';

// Keep `/try` and `/demo` unprotected, but render the exact same scene canvas/runtime
// as the scene lesson route so styling and behavior stay fully aligned.
const PublicSceneDemoPage = () => <SceneLessonPage useStaticDemo />;

export default PublicSceneDemoPage;
